<template>
  <div id="PaymentOrder">
    <v-dialog v-model="open" persistent max-width="1200">
      <v-card class="align-center">
        <v-card-text>
          <div class="d-flex justify-space-between align-center">
            <h1 class="py-6 text-left">Nova ordem de pagamento</h1>
            <v-btn icon @click="close(false)">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </div>
          <v-row class="mt-1 payment-order-info">
            <v-col cols="6" md="4">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="true"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="formattedDate"
                    label="Previsão de Pagamento"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="paymentForecast" locale="pt-br"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4">
              <p class="mb-2">
                {{ transhipment ? 'Transbordo' : 'Entregador' }}
              </p>
              <span>{{ selectedFather.data.name }}</span>
            </v-col>
          </v-row>

          <h1 class="my-6 text-left">Descrição de Entradas</h1>
          <v-row v-if="unselectedFatherItems.length > 0" dense class="mt-4">
            <v-col>
              <v-expansion-panels>
                <v-expansion-panel class="elevation-2">
                  <v-expansion-panel-header class="px-4 panel-header">
                    <h4>
                      {{
                        transhipment
                          ? 'O transbordo ainda possui outras paradas disponíveis'
                          : 'O entregador ainda possui outras entregas disponíveis'
                      }}
                    </h4>
                    <template v-slot:actions>
                      <v-icon color="black"> mdi-chevron-down </v-icon>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="mx-4 mt-4 d-flex flex-column">
                      <v-data-table
                        v-model="unselectedItems"
                        :headers="unselectedFatherItemsColumns"
                        :items="unselectedFatherItems"
                        :items-per-page="unselectedFatherItems.length"
                        fixed-header
                        :height="unselectedEntriesTableHeight"
                        item-key="data.id"
                        show-select
                        hide-default-footer
                      >
                        <template v-slot:[`item.data.advanceAmount`]="{ item }">
                          {{ transformPrice(item.data.advanceAmount) }}
                        </template>
                        <template v-slot:[`item.data.price`]="{ item }">
                          {{ transformPrice(item.data.price) }}
                        </template>
                      </v-data-table>
                      <div class="my-4 d-flex justify-end">
                        <v-btn
                          :disabled="unselectedItems.length == 0"
                          color="success"
                          @click="addToStatement(unselectedItems)"
                        >
                          Adicionar à ordem de pagamento
                        </v-btn>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="table px-0">
                <v-data-table
                  :headers="statementColumns"
                  :items="getValidStatementData"
                  :items-per-page="getValidStatementData.length"
                  fixed-header
                  :height="entriesTableHeight"
                  no-data-text="Nenhuma entrada registrada"
                  item-key="key"
                  hide-default-footer
                >
                  <template v-slot:[`item.removeAction`]="{ item }">
                    <v-btn
                      :disabled="getValidStatementData.length == 1"
                      color="error"
                      @click="removeFromStatement(item)"
                    >
                      Remover
                    </v-btn>
                  </template>
                  <template v-slot:[`item.data.advanceAmount`]="{ item }">
                    {{ transformPrice(item.data.advanceAmount) }}
                  </template>
                  <template v-slot:[`item.data.price`]="{ item }">
                    {{ transformPrice(item.data.price) }}
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>

          <h1 class="mt-8 mb-4 text-left">Descrição de Adicionais</h1>
          <a href="#/financial/aditionals" target="_blank"> Clique aqui para incluir novos adicionais </a>
          <v-row v-if="open" dense class="mt-4">
            <v-col>
              <related-aditionals-panel
                :applicationUserId="applicationUserId"
                :isTranshipmentAditionals="transhipment"
                v-model="relatedAditionals"
                :aditionalRelated="aditionals"
                @clickAddAditionals="onClickAddRelatedAditional"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <div class="table px-0">
                <v-data-table
                  :headers="additionColumns"
                  :items="aditionals"
                  :items-per-page="aditionals.length"
                  no-data-text="Nenhum adicional registrado"
                  item-key="key"
                  hide-default-footer
                >
                  <template v-slot:[`item.removeAction`]="{ item }">
                    <v-btn color="error" @click="removeAditional(item)"> Remover </v-btn>
                  </template>
                  <template v-slot:[`item.boardingId`]="{ item }">
                    {{ getStopOrBoardingId(item.boardingId) }}
                  </template>
                  <template v-slot:[`item.stopId`]="{ item }">
                    {{ getStopOrBoardingId(item.stopId) }}
                  </template>
                  <template v-slot:[`item.price`]="{ item }">
                    {{ transformPrice(item.price) }}
                  </template>
                  <template v-slot:[`item.isDiscount`]="{ item }">
                    {{ getAditionalIsDiscount(item.isDiscount) }}
                  </template>
                  <template v-slot:[`item.additionalDate`]="{ item }">
                    {{ getAdditionalDate(item.additionalDate) }}
                  </template>
                  <template v-slot:[`item.justification`]="{ item }">
                    {{ getAditionalJustification(item.justification) }}
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
          <v-divider inset class="my-6 mx-auto"></v-divider>
          <v-row>
            <v-col class="d-flex justify-space-around mx-12">
              <div class="d-flex money-cards">
                <div class="circle">
                  <v-icon class="pa-3" large color="white"> mdi-cash-minus </v-icon>
                </div>
                <span class="d-flex px-2 flex-column justify-center"
                  >TOTAL DE DÉBITOS
                  <strong>{{ transformPrice(paymentDiscount) }}</strong>
                </span>
              </div>
              <div class="d-flex money-cards">
                <div class="circle">
                  <v-icon class="pa-3" large color="white"> mdi-cash-plus </v-icon>
                </div>
                <span class="d-flex px-2 flex-column justify-center"
                  >TOTAL DE CRÉDITOS
                  <strong> {{ transformPrice(paymentValue) }}</strong>
                </span>
              </div>
              <div class="d-flex money-cards">
                <div class="circle">
                  <v-icon class="pa-3" large color="white"> mdi-cash-register </v-icon>
                </div>
                <span class="d-flex px-2 flex-column justify-center"
                  >TOTAL DA ORDEM
                  <strong>
                    {{ transformPrice(paymentValue - paymentDiscount) }}
                  </strong>
                </span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-end py-5">
          <v-btn color="error" class="mx-1 px-5" large @click="close(false), (paymentForecast = null)">
            Cancelar
          </v-btn>
          <v-btn color="success" class="px-5" :disabled="paymentForecast === null" large @click="savePaymentOrder()">
            Salvar programação de pagamento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import maskData from '../../utils/maskData';
import maskPrice from '../../utils/maskPrice';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { VMoney } from 'v-money';
import RelatedAditionalsPanel from '@/components/AccountsPayable/RelatedAditionalsPanel';
export default {
  name: 'PaymentOrder',
  components: {
    RelatedAditionalsPanel
  },
  props: {
    open: {
      default: () => false,
      type: Boolean
    },
    selectedFather: {
      default: () => null,
      type: Object
    },
    selectedItems: {
      default: () => [],
      type: Array
    },
    transhipmentAllItems: {
      default: () => [],
      type: Array
    },
    transhipment: {
      default: () => false,
      type: Boolean
    }
  },
  data: () => ({
    justifications: [],
    relatedAditionals: [],
    aditionals: [],
    statementData: [],
    unselectedItems: [],
    menu: false,
    menu1: false,
    paymentForecast: null,
    valid: false,
    aditional: {
      isDiscount: null,
      boardingOrStopId: null,
      additionalDate: null,
      price: null,
      justification: '',
      observation: ''
    },
    aditionalType: [
      { text: 'Crédito', value: false },
      { text: 'Débito', value: true }
    ],
    rules: {
      required: (value) => !!value || 'Campo obrigatório!',
      requiredIsDiscount: (value) => !value != null || 'Campo obrigatório!'
    },
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false /* doesn't work with directive */
    }
  }),
  directives: { money: VMoney },
  watch: {
    open(val) {
      if (val) {
        this.aditionals = [];
        this.relatedAditionals = [];
        this.statementData = this.selectedItems.map((item) => {
          return {
            data: {
              ...item,
              type: 'Crédito',
              isAditional: false
            },
            key: Math.floor(Math.random() * 90000) + 10000
          };
        });
        if (this.$refs.aditionalForm) {
          this.$refs.price.$el.getElementsByTagName('input')[0].value = 0;
          this.$refs.aditionalForm.reset();
        }
      }
    },
    'aditional.isDiscount': {
      handler(_, oldIsDiscount) {
        if (oldIsDiscount !== null) {
          this.aditional.justification = null;
        }
        this.fetchAllJustifications();
      }
    }
  },

  computed: {
    ...mapGetters('NfeStore', ['getJustificationsById']),

    formattedDate() {
      const date = this.paymentForecast;
      if (date === null) return '';
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    applicationUserId() {
      const hasSelectedFather = this.selectedFather !== null;
      const isOpen = this.open;
      return isOpen && hasSelectedFather ? this.selectedFather.data.userId : null;
    },
    unselectedFatherItems() {
      if (this.transhipment) {
        const itemsId = this.statementData.map((item) => item.data.id);
        const unselectedFatherItems = this.transhipmentAllItems.filter((item) => {
          if (!itemsId.includes(item.data.id)) {
            return item;
          }
        });
        return unselectedFatherItems;
      } else {
        const itemsId = this.statementData.map((item) => item.data.id);
        const unselectedFatherItems = this.selectedFather.children.filter((item) => {
          if (!itemsId.includes(item.data.id)) {
            return item;
          }
        });
        return unselectedFatherItems;
      }
    },
    paymentDiscount() {
      const aditionalDiscounts = this.aditionals
        .filter((aditional) => aditional.isDiscount)
        .map((aditional) => aditional.price);
      return aditionalDiscounts.reduce((acc, cur) => (acc += cur), 0);
    },
    paymentValue() {
      var total = 0;
      this.statementData.map((item) => {
        if (this.transhipment) {
          item.data.type === 'Crédito' ? (total = parseFloat(total) + parseFloat(item.data.price)) : 0;
        } else {
          let creditValue = item.data.price - item.data.advanceAmount;
          item.data.type === 'Crédito' ? (total = parseFloat(total) + parseFloat(creditValue)) : 0;
        }
      });
      const aditionalCredits = this.aditionals
        .filter((aditional) => !aditional.isDiscount)
        .map((aditional) => aditional.price);
      const creditsSum = aditionalCredits.reduce((acc, cur) => (acc += cur), 0);
      return total + creditsSum;
    },
    statementColumns() {
      const transhipmentColumns = [
        {
          value: 'data.id',
          text: `ID DA PARADA`
        },
        {
          value: `data.boardingNumber`,
          text: 'EMBARQUES EXTERNOS'
        },
        {
          value: `data.numbersCte`,
          text: 'NÚMEROS CTES'
        },
        {
          value: 'data.price',
          text: 'VALOR TOTAL'
        },
        {
          value: 'removeAction',
          align: 'end'
        }
      ];
      const delivererColumns = [
        {
          value: 'data.id',
          text: `ID DO EMBARQUE`,
          sortable: false
        },
        {
          value: `data.numbers`,
          text: 'EMBARQUES EXTERNOS',
          sortable: false
        },
        { value: 'data.advanceAmount', text: 'ADIANTAMENTO', sortable: false },
        { value: 'data.advanceStatus', text: 'STATUS DO ADIANTAMENTO', sortable: false },
        {
          value: 'data.price',
          text: 'VALOR DO FRETE',
          sortable: false
        },
        {
          value: 'removeAction',
          align: 'end',
          sortable: false
        }
      ];
      return this.transhipment ? transhipmentColumns : delivererColumns;
    },
    additionColumns() {
      return [
        {
          value: this.transhipment ? 'stopId' : 'boardingId',
          text: `ID ${this.transhipment ? 'DA PARADA' : 'DO EMBARQUE'}`
        },
        {
          value: 'isDiscount',
          text: 'TIPO'
        },
        {
          value: 'price',
          text: 'VALOR'
        },
        {
          value: 'additionalDate',
          text: 'DATA'
        },
        {
          value: 'justification',
          text: 'JUSTIFICATIVA'
        },
        {
          value: 'observation',
          text: 'OBSERVAÇÃO'
        },
        {
          value: 'removeAction',
          align: 'end',
          sortable: false
        }
      ];
    },
    unselectedFatherItemsColumns() {
      const hasAdvance = !this.transhipment;
      return [
        {
          value: 'data.id',
          text: `ID ${this.transhipment ? 'DA PARADA' : 'DO EMBARQUE'}`
        },
        {
          value: 'data.createdAt',
          text: 'PERÍODO'
        },
        ...(hasAdvance ? [{ value: 'data.advanceAmount', text: 'ADIANTAMENTO' }] : []),
        {
          value: 'data.price',
          text: 'VALOR DO FRETE'
        }
      ];
    },
    getValidStatementData() {
      const dataItems = [];
      this.statementData.map((item) => {
        if (!item.data.isAditional) {
          dataItems.push(item);
        }
      });
      return dataItems;
    },
    getAdditionalStatementData() {
      const dataItems = [];
      this.statementData.map((item) => {
        if (item.data.isAditional) {
          dataItems.push(item);
        }
      });
      return dataItems;
    },

    boardingOrStopIdNoDataText() {
      return `Digite um id de ${this.transhipment ? 'parada' : 'embarque'} disponível`;
    },

    unselectedEntriesTableHeight() {
      const hasMoreThanFiveEntries = this.unselectedFatherItems.length > 5;
      return hasMoreThanFiveEntries ? '285' : '';
    },

    entriesTableHeight() {
      const hasMoreThanFiveEntries = this.getValidStatementData.length > 5;
      return hasMoreThanFiveEntries ? '285' : '';
    },

    shouldDisableJustification() {
      return this.aditional.isDiscount === null;
    },

    justificationsNumber() {
      return this.aditional.isDiscount ? 11 : 10;
    },

    shouldDisableAddButton() {
      const { isDiscount, price, createdAt, justification } = this.aditional;
      return (
        isDiscount === null || this.transformAditionalPrice(price) === 0 || createdAt === null || justification === null
      );
    },
    formattedCreatedDate() {
      if (!this.aditional.createdAt) return '';
      const [year, month, day] = this.aditional.createdAt.split('-');
      return `${day}/${month}/${year}`;
    }
  },

  async created() {
    const discountJustifications = await this.getJustifications(11);
    const creditsJustifications = await this.getJustifications(10);
    this.setJustificationsById([...discountJustifications, ...creditsJustifications]);
  },

  methods: {
    ...mapActions('NfeStore', ['fetchJustificationsById', 'fetchJustification']),
    ...mapActions('AccountsStore', ['createPaymentOrder', 'getAllAditionals']),
    ...mapMutations('NfeStore', ['setJustificationsById']),

    async fetchAllJustifications() {
      try {
        this.justifications = await this.fetchJustification(this.justificationsNumber);
      } catch (e) {
        console.error(e);
      }
    },
    async getJustifications(id) {
      try {
        return this.fetchJustification(id);
      } catch (error) {
        console.error(error);
      }
    },

    getStopOrBoardingId(stopOrBoardingId) {
      return stopOrBoardingId ? stopOrBoardingId : '-';
    },
    getAditionalIsDiscount(isDiscount) {
      return isDiscount ? 'Débito' : 'Crédito';
    },
    getAdditionalDate(additionalDate) {
      const [year, month, day] = additionalDate.slice(0, 10).split('-');
      return `${day}/${month}/${year}`;
    },
    getAditionalJustification(justification) {
      return typeof justification === 'string' ? justification : justification.name;
    },
    onClickAddRelatedAditional(relatedAditionals) {
      this.aditionals = [...this.aditionals, ...relatedAditionals];
    },
    onRelatedAditionalRemove(relatedAditional) {
      this.relatedAditionals = [...this.relatedAditionals, relatedAditional];
    },
    removeAditional(aditional) {
      const aditionalIndex = this.aditionals.indexOf(aditional);
      this.aditionals.splice(aditionalIndex, 1);
      if (aditional.isRelatedAditional) {
        this.relatedAditionals = [...this.relatedAditionals, aditional];
      }
    },

    close(hasChange, message) {
      this.statementData = [];
      this.$emit('closePaymentOrder', hasChange, message);
    },
    transformPriceToSend(element) {
      var money = element.toString().trim();
      money = money.replace('R$ ', '').replaceAll('.', '').replace(',', '.');
      return money;
    },
    transformAditionalPrice(element) {
      if (!element) return null;
      var money = element.toString().trim();
      money = money.replace('R$ ', '').replaceAll('.', '').replace(',', '.');
      return Number(money);
    },

    createOrderModel() {
      const boardingIds = [];
      const stopIds = [];

      this.statementData.map((element) => {
        if (this.transhipment) {
          stopIds.push(element.data.id);
        } else {
          boardingIds.push(element.data.id);
        }
      });

      const aditionalsIds = this.aditionals.map((item) => item.id);

      let model = {
        boardingsIds: boardingIds,
        cargosIds: [],
        stopsIds: stopIds,
        deliveriesIds: [],
        paymentForecast: this.paymentForecast,
        additionals: {
          id: aditionalsIds
        }
      };
      return model;
    },

    async savePaymentOrder() {
      const model = this.createOrderModel();
      try {
        const data = await this.createPaymentOrder(model);
        if (data.success) {
          this.message = {
            errors: ['Ordem de pagamento criada com sucesso!'],
            errorsType: 'success'
          };
        } else {
          this.message = {
            errors: ['Erro ao criar ordem de pagamento!'],
            errorsType: 'error',
            error500: data
          };
        }
      } catch (e) {
        console.error(e);
        this.message = {
          errors: ['Opss, algo deu errado!'],
          errorsType: 'error'
        };
      } finally {
        this.close(true, this.message);
        this.paymentForecast = null;
      }
    },

    addToStatement(newItems) {
      newItems.map((item) => {
        item = {
          data: { ...item.data, type: 'Crédito', isAditional: false },
          key: Math.floor(Math.random() * 90000) + 10000
        };
        this.statementData.push(item);
      });
      this.unselectedItems = [];
    },
    removeFromStatement(itemData) {
      if (itemData.data.id === this.aditional.id) {
        this.aditional.id = null;
      }
      this.statementData = this.statementData.filter((item) => {
        return item.key !== itemData.key;
      });
    },
    getJustificationName(id) {
      const name = this.getJustificationsById.map((element) => {
        if (element.id === id) return element.name;
      });
      return name;
    },
    addAditional() {
      const isTranshipmentPaymentOrder = this.transhipment;
      const { price, boardingOrStopId, ...rest } = this.aditional;
      const aditional = {
        ...rest,
        price: Number(this.transformPriceToSend(price)),
        stopId: isTranshipmentPaymentOrder ? boardingOrStopId : null,
        boardingId: !isTranshipmentPaymentOrder ? boardingOrStopId : null,
        isRelatedAditional: false
      };
      this.aditionals = [...this.aditionals, aditional];

      this.$refs.price.$el.getElementsByTagName('input')[0].value = 0;
      this.$refs.aditionalForm.reset();
    },
    clearInputFields() {
      this.$refs.aditionalForm.reset();
    },
    transformDate(date) {
      return maskData(date);
    },
    transformPrice(price) {
      return maskPrice(price);
    }
  }
};
</script>

<style lang="scss" scoped>
.panel-header {
  background: $--color-table-offset;
}
.payment-order-info {
  p {
    color: $--color-primary;
  }
}
.money-cards {
  padding: 10px 28px;
  border-radius: 5px;
  background: #1f77b4;
  color: white;
  span {
    font-size: 0.8rem;
    strong {
      font-size: 1.3rem;
      font-weight: 600;
    }
  }
  .circle {
    background: #1f77b4;
    border: solid 1px white;
    border-radius: 100%;
    padding: 0px;
  }
}
.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
::v-deep .v-data-table-header tr th {
  background-color: #e0e0e0 !important;
  border: 1px solid #e0e0e0;
}
</style>
